var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "total-transaction-pannel" },
    [
      _c(
        "div",
        { staticClass: "total-title" },
        [
          _c(
            "div",
            [
              _vm._v(" " + _vm._s(_vm.$t("dashboard.today_overview")) + " "),
              _vm.$store.getters.isPii
                ? _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("tips.current_time_zone"))),
                      ]),
                    ]),
                    _c(
                      "span",
                      [
                        _c("svg-icon", {
                          staticStyle: {
                            width: "22px",
                            color: "#3855F1",
                            cursor: "pointer",
                          },
                          attrs: { "icon-class": "icon-font-warning" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.$store.getters.isAllCountry
            ? _c(
                "el-select",
                {
                  staticClass: "currency-select",
                  attrs: {
                    size: "small",
                    placeholder: _vm.$t("data.currency"),
                  },
                  on: { change: _vm.handleCurrencyChange },
                  model: {
                    value: _vm.currency,
                    callback: function ($$v) {
                      _vm.currency = $$v
                    },
                    expression: "currency",
                  },
                },
                _vm._l(
                  _vm.$store.state.page.countryArr,
                  function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.currency, value: item.currency },
                    })
                  }
                ),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("dashboard.total_transaction"),
                name: "first",
              },
            },
            [
              _c(
                "el-row",
                { staticClass: "panel-group", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_count")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(_vm._s(_vm.overviewData.total_count || 0)),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_amount")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.overviewData.total_amount
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_fee")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.overviewData.total_fee
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("dashboard.payin"), name: "second" } },
            [
              _c(
                "el-row",
                { staticClass: "panel-group", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_count")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(_vm._s(_vm.overviewData.payment_count || 0)),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_amount")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.overviewData.payment_total_amount
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_fee")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.overviewData.payment_fee
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { name: "third" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(" " + _vm._s(_vm.$t("dashboard.payout")) + " "),
              ]),
              _c(
                "el-row",
                { staticClass: "panel-group", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_count")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(_vm._s(_vm.overviewData.payout_count || 0)),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_amount")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.overviewData.payout_total_amount
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-col",
                    { staticClass: "card-panel-col", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "card-panel" }, [
                        _c("div", { staticClass: "card-panel-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("dashboard.transaction_fee")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-panel-num" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                _vm.overviewData.payout_fee
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }